import { buttonLoader } from '../general/functions';
import { BASE_URL } from '../general/variables';

const loginValidation =
  $('#loginForm').length > 0
    ? FormValidation.formValidation(document.getElementById('loginForm'), {
        fields: {
          username: {
            validators: {
              notEmpty: {
                message: 'Username cannot be empty',
              },
            },
          },
          password: {
            validators: {
              notEmpty: {
                message: 'Password cannot be empty',
              },
            },
          },
        },
        plugins: {
          trigger: new FormValidation.plugins.Trigger(),
          bootstrap: new FormValidation.plugins.Bootstrap(),
        },
      })
    : null;

$('#loginForm').on('submit', function (evt) {
  evt.preventDefault();

  const formButton = $('#loginForm').find('button[type="submit"]');

  KTApp.block('#loginForm', {
    opacity: 0.1,
    state: 'primary',
    message: 'Please Wait...',
  });

  loginValidation.validate().then(function (status) {
    if (status == 'Valid') {
      buttonLoader(formButton, 'loading', null);

      $.post(
        BASE_URL + 'Dashboard/postLogin',
        {
          username: $('[name="username"]').val(),
          password: $('[name="password"]').val(),
        },
        function (resp) {
          if (resp.code == 200) {
            Swal.fire({
              html: `Welcome back, <strong>${resp.details}</strong>`,
              icon: 'success',
              confirmButtonText: 'Close',
              showCancelButton: false,
            }).then(function () {
              if (resp.redirect.status) {
                window.location.href = resp.redirect.link;
              } else {
                window.location.href = BASE_URL + 'dashboard';
              }
            });
          } else {
            Swal.fire({
              html: `<strong>${resp.message}</strong>`,
              icon: 'warning',
              confirmButtonText: 'Close',
              showCancelButton: false,
            });

            KTApp.unblock('#loginForm');
            buttonLoader(formButton, 'failed', 'Login');
          }
        }
      ).fail(function (err) {
        Swal.fire({
          html: `Cannot process request, please try again later`,
          icon: 'error',
          confirmButtonText: 'Close',
          showCancelButton: false,
        });

        console.log('error', err);

        KTApp.unblock('#loginForm');
        buttonLoader(formButton, 'failed', 'Login');
      });
    } else {
      KTApp.unblock('#loginForm');
      buttonLoader(formButton, 'failed', 'Login');
    }
  });
});
